export const PAYMENT_TYPE = 'payment_method_type';
export const PAYMENT_METHOD = 'payment_method';
export const PAYMENT_METHOD_ID = 'payment_method_id';
export const PAYMENT_NUMBER = 'payment_number';
export const PAYMENT_DATE = 'payment_date';
export const AMOUNT = 'amount';
export const PAID = 'paid';
export const NOTES = 'notes';
//this is for frontend only, payment amount is payment.amount
export const PAYMENT_AMOUNT = 'payment_amount';

export const PAYMENT_TYPE_BANK = 'bank';
export const PAYMENT_TYPE_CHECK = 'check';
export const PAYMENT_TYPE_CREDIT_CARD = 'credit_card';
export const PAYMENT_TYPE_ACH = 'ach';
export const PAYMENT_TYPE_OTHER = 'other';
export const PAYMENT_METHOD_TRANSACTION_ID = 'payment_method_transaction_id';

//PAYMENT METHODS
export const PAYMENT_TYPE_LABELS = [
  {
    value: PAYMENT_TYPE_BANK,
    label: 'Bank'
  },
  {
    value: PAYMENT_TYPE_CHECK,
    label: 'Check'
  },
  {
    value: PAYMENT_TYPE_CREDIT_CARD,
    label: 'Credit Card'
  },
  {
    value: PAYMENT_TYPE_ACH,
    label: 'ACH'
  },
  {
    value: PAYMENT_TYPE_OTHER,
    label: 'Other'
  }
];
